const __vite__mapDeps=(i,m=__vite__mapDeps,d=(m.f||(m.f=["-toggle-play-pause.js","chunk-BaseElement-COVKFV2h.js","chunk-lit-element-CULRVKo8.js","chunk-toggle-play-pause-helpers-BTz_nSF_.js"])))=>i.map(i=>d[i]);
import{_ as ee}from"./chunk-preload-helper-D7HrI6pR.js";import{B as te}from"./chunk-BaseElement-COVKFV2h.js";import"./-product-card-gallery.js";import{W as re}from"./chunk-WithApiClient-TEbzi3fY.js";import{W as ie}from"./chunk-WithShopifyCart-RfU-uQyo.js";import{h as D}from"./chunk-task-Nh5oQ4sG.js";import{T as y,x as u}from"./chunk-lit-element-CULRVKo8.js";import{t as ae}from"./chunk-custom-element-BhZVzxrc.js";import{n as P}from"./chunk-property-BXqvfTtY.js";import{r as z}from"./chunk-state-BP5Nb0So.js";import{r as oe}from"./chunk-query-all-Dwm6l2K0.js";import{o as ne}from"./chunk-unsafe-html-BZRX-HF1.js";import"./-core-carousel.js";import"./chunk-query-DKWSFbGJ.js";import"./chunk-base-DIkkzJ-c.js";import"./chunk-index-CKJCYK2x.js";import"./chunk-create-context-89xeped_.js";import"./chunk-consume-BU4pVwFi.js";import"./chunk-directive-CF8sV3Lr.js";const I={OPTION:":",END_OF_PREFIX:",",SEQUENCE_GAP:" ",RANGE:"-"},se=e=>e.replace(/^v1_/,"");function le(e){const r=/[ :,-]/g;let t=0,i;const a=[],o=[];let n=0,s=null;for(;i=r.exec(e);){const l=i[0],d=Number.parseInt(e.slice(t,i.index))||0;if(s!==null){for(;s<d;s++)o[n]=s,a.push([...o]);s=null}o[n]=d,l===I.RANGE?s=d:l===I.OPTION?n++:((l===I.SEQUENCE_GAP||l===I.END_OF_PREFIX&&e[i.index-1]!==I.END_OF_PREFIX)&&a.push([...o]),l===I.END_OF_PREFIX&&(o.pop(),n--)),t=r.lastIndex}const c=e.match(/\d+$/g);if(c){const l=parseInt(c[0]);if(s!=null)for(;s<=l;s++)o[n]=s,a.push([...o]);else a.push([l])}return a}function ce(e){if(!e)return[];if(e.startsWith("v1_"))return le(se(e));throw new Error("Unsupported option value encoding")}const U=",",j=new Map;function de(e,r){var t;if(e.length===0||!r)return!1;if(!j.has(r)){const i=new Set;for(const a of ce(r)){i.add(a.join(U));for(let o=0;o<a.length;o++)i.add(a.slice(0,o+1).join(U))}j.set(r,i)}return!!((t=j.get(r))!=null&&t.has(e.join(U)))}const Y=/\{\{\s*(\w+)\s*\}\}/;function ue(e,r,t,i){if(isNaN(e))return"0";const a=(e/100).toFixed(r).split("."),o=a[0].replace(/(\d)(?=(\d{3})+(?!\d))/g,`$1${t}`),n=a[1]?i+a[1]:"";return o+n}function pe(e){return Math.round(parseFloat(String(e))*100)}function he(e,r,t){if(!t.match(Y))return t;const a=ue(e,r,",",".");return t.replace(Y,a)}function B(e){var a;const r=((a=window.productCardSettings)==null?void 0:a.moneyFormat)||"${{amount}}",t=pe(e),i=t%100===0?0:2;return he(t,i,r)}function N(e,r){const t=new URL(e);return t.searchParams.set("width",String(r)),t.toString()}function fe(e,r){return r.map(t=>`${N(e,t)} ${t}w`).join(", ")}function ge(e,r=t=>t.name){return e.map((t,i)=>({value:t,rank:ye(r(t),i)})).sort((t,i)=>t.rank.tier-i.rank.tier||t.rank.primary-i.rank.primary||t.rank.secondary-i.rank.secondary).map(t=>t.value)}const me=["xxs","xs","s","m","l","xl","xxl","xxxl","one size"];function ye(e,r){const t=e.trim().toLowerCase(),i=(t.match(/\./g)??[]).length;if(t!==""&&i<=1&&/^[0-9.]+$/.test(t))return{tier:1,primary:parseFloat(t),secondary:-t.length};const o=me.indexOf(t);return o>=0?{tier:0,primary:o,secondary:0}:{tier:2,primary:r,secondary:0}}var be=Object.defineProperty,ve=Object.getOwnPropertyDescriptor,v=(e,r,t,i)=>{for(var a=i>1?void 0:i?ve(r,t):r,o=e.length-1,n;o>=0;o--)(n=e[o])&&(a=(i?n(r,t,a):n(a))||a);return i&&a&&be(r,t,a),a};customElements.get("toggle-play-pause")||ee(()=>import("./-toggle-play-pause.js"),__vite__mapDeps([0,1,2,3])).catch(()=>{});const we=`#graphql
  query getProductVariantsFromNode($id: ID!) {
    node(id: $id) {
      id
      ... on ProductVariant {
        product {
          handle
        }
      }
    }
  }
`,q=`
  handle
  text: field(key: "text") { value }
  customerGroupId: field(key: "customer_group_id") { value }
  textColor: field(key: "text_color") { value }
  backgroundColor: field(key: "background_color") { value }
  image: field(key: "image") {
    reference {
      ... on MediaImage {
        image {
          url
        }
      }
    }
  }
  excludeByCountryGroups: field(key: "exclude_by_country_groups") {
    references(first: 10) {
      nodes {
        ... on Metaobject {
          countries: field(key: "countries") {
            references(first: 50) {
              nodes {
                ... on Metaobject {
                  code: field(key: "code") {
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`,_e=`#graphql
  query getSnapProductCardData($handle: String!, $country: CountryCode!)
  @inContext(country: $country) {
    product(handle: $handle) {
      id
      title
      handle
      availableForSale
      media(first: 8) {
        nodes {
          __typename
          ... on MediaImage {
            image {
              url
              altText
            }
          }
          ... on Video {
            id
            alt
            previewImage {
              url
            }
            sources {
              url
              mimeType
            }
          }
        }
      }
      selectedOrFirstAvailableVariant {
        id
        availableForSale
        selectedOptions {
          name
          value
        }
        price {
          amount
          currencyCode
        }
        compareAtPrice {
          amount
          currencyCode
        }
        preOrderMetafield: metafield(namespace: "custom", key: "pre_order") {
          value
        }
        customBadgesMetafield: metafield(namespace: "custom", key: "badges") {
          references(first: 10) {
            nodes {
              ... on Metaobject {
                ${q}
              }
            }
          }
        }
      }
      finalSaleMetafield: metafield(namespace: "custom", key: "final_sale") {
        value
      }
      waitlistMetafield: metafield(namespace: "custom", key: "waitlist") {
        value
      }
      hideBadgesMetafield: metafield(namespace: "custom", key: "hide_badges") {
        value
      }
      customBadgesMetafield: metafield(namespace: "custom", key: "badges") {
        references(first: 10) {
          nodes {
            ... on Metaobject {
              ${q}
            }
          }
        }
      }
      options {
        name
        optionValues {
          id
          name
          swatch {
            color
            image {
              ... on MediaImage {
                image {
                  url
                }
              }
            }
          }
        }
      }
      encodedVariantAvailability
    }
    badgePriority: metaobjects(type: "badge_priority", first: 1) {
      nodes {
        badges: field(key: "badges") {
          references(first: 50) {
            nodes {
              ... on Metaobject {
                handle
              }
            }
          }
        }
      }
    }
  }
`,xe=`#graphql
  query getSnapProductCardDataFull($handle: String!, $country: CountryCode!)
  @inContext(country: $country) {
    product(handle: $handle) {
      id
      title
      handle
      availableForSale
      media(first: 8) {
        nodes {
          __typename
          ... on MediaImage {
            image {
              url
              altText
            }
          }
          ... on Video {
            id
            alt
            previewImage {
              url
            }
            sources {
              url
              mimeType
            }
          }
        }
      }
      selectedOrFirstAvailableVariant {
        id
        availableForSale
        selectedOptions {
          name
          value
        }
        price {
          amount
          currencyCode
        }
        compareAtPrice {
          amount
          currencyCode
        }
        preOrderMetafield: metafield(namespace: "custom", key: "pre_order") {
          value
        }
        customBadgesMetafield: metafield(namespace: "custom", key: "badges") {
          references(first: 10) {
            nodes {
              ... on Metaobject {
                ${q}
              }
            }
          }
        }
      }
      finalSaleMetafield: metafield(namespace: "custom", key: "final_sale") {
        value
      }
      waitlistMetafield: metafield(namespace: "custom", key: "waitlist") {
        value
      }
      hideBadgesMetafield: metafield(namespace: "custom", key: "hide_badges") {
        value
      }
      customBadgesMetafield: metafield(namespace: "custom", key: "badges") {
        references(first: 10) {
          nodes {
            ... on Metaobject {
              ${q}
            }
          }
        }
      }
      options {
        name
        optionValues {
          id
          name
          swatch {
            color
            image {
              ... on MediaImage {
                image {
                  url
                }
              }
            }
          }
          firstSelectableVariant {
            id
            availableForSale
            selectedOptions {
              name
              value
            }
            image {
              url
              altText
            }
            price {
              amount
              currencyCode
            }
            compareAtPrice {
              amount
              currencyCode
            }
            product {
              handle
              colorPatternMetafield: metafield(namespace: "shopify", key: "color-pattern") {
                reference {
                  ... on Metaobject {
                    color: field(key: "color") {
                      value
                    }
                    image: field(key: "image") {
                      reference {
                        ... on MediaImage {
                          image {
                            url
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      encodedVariantAvailability
    }
    badgePriority: metaobjects(type: "badge_priority", first: 1) {
      nodes {
        badges: field(key: "badges") {
          references(first: 50) {
            nodes {
              ... on Metaobject {
                handle
              }
            }
          }
        }
      }
    }
  }
`,$e=`#graphql
  query getSnapSwatchVariants($ids: [ID!]!, $country: CountryCode!)
  @inContext(country: $country) {
    nodes(ids: $ids) {
      id
      ... on ProductOptionValue {
        firstSelectableVariant {
          id
          availableForSale
          selectedOptions {
            name
            value
          }
          image {
            url
            altText
          }
          price {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
            currencyCode
          }
          product {
            handle
            colorPatternMetafield: metafield(namespace: "shopify", key: "color-pattern") {
              reference {
                ... on Metaobject {
                  color: field(key: "color") {
                    value
                  }
                  image: field(key: "image") {
                    reference {
                      ... on MediaImage {
                        image {
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`,Se=`#graphql
  query getSnapVariantForSelectedOptions(
    $handle: String!
    $country: CountryCode!
    $selectedOptions: [SelectedOptionInput!]!
  ) @inContext(country: $country) {
    product(handle: $handle) {
      selectedOrFirstAvailableVariant(
        selectedOptions: $selectedOptions
        ignoreUnknownOptions: true
      ) {
        id
        availableForSale
        selectedOptions {
          name
          value
        }
      }
    }
  }
`;function J(e,r,t){var i;return H(e)?(i=r==null?void 0:r.find(a=>a.name===e.name))==null?void 0:i.value:t[e.name]}function Ce(e){return e.name.toLowerCase()==="size"?ge(e.optionValues):e.optionValues}function ke(e){let r=null;const t=[];for(const i of e){if(i.__typename==="Video"&&t.length===1&&!r){r=i;continue}t.push(i)}return{gallerySlides:t,hoverVideoMedia:r}}function Oe(e,r,t){const i=[];for(const a of e.options){const o=J(a,r,t);if(o===void 0)break;const n=a.optionValues.findIndex(s=>s.name===o);if(n===-1)return null;i.push(n)}return i}function Pe(e,r,t){const i=Oe(e,r,t);return!i||!i.length?!1:de(i,e.encodedVariantAvailability)}function Ve(e,r,t){return e.options.flatMap(i=>{const a=J(i,r,t);return a?[{name:i.name,value:a}]:[]})}function Z(e){var t,i,a,o,n,s,c,l,d,g,b,h;if((t=e.swatch)!=null&&t.color||(i=e.swatch)!=null&&i.image)return{color:((a=e.swatch)==null?void 0:a.color)??null,imageUrl:((s=(n=(o=e.swatch)==null?void 0:o.image)==null?void 0:n.image)==null?void 0:s.url)??null};const r=(l=(c=e.firstSelectableVariant)==null?void 0:c.product.colorPatternMetafield)==null?void 0:l.reference;return{color:((d=r==null?void 0:r.color)==null?void 0:d.value)??null,imageUrl:((h=(b=(g=r==null?void 0:r.image)==null?void 0:g.reference)==null?void 0:b.image)==null?void 0:h.url)??null}}function H(e){return e.optionValues.some(r=>{const t=Z(r);return t.color||t.imageUrl})}const F=5;function Ie(e){var i,a;const r=((a=(i=e.excludeByCountryGroups)==null?void 0:i.references)==null?void 0:a.nodes)??[];if(!r.length)return!1;const t=window.CUSTOMER_COUNTRY||"";return r.some(o=>{var n,s;return(((s=(n=o.countries)==null?void 0:n.references)==null?void 0:s.nodes)??[]).some(c=>{var l;return((l=c.code)==null?void 0:l.value)===t})})}function Me(e){return e?Object.entries(e).filter(([r,t])=>/^segment_\d+$/.test(r)&&t!=="").map(([,r])=>String(r)):[]}function Ae(e,r){var i;if(!window.productCardSettings.showPersonalizedBadge)return!0;const t=(i=e.customerGroupId)==null?void 0:i.value;return t?t.split(",").map(a=>a.trim()).some(a=>r.includes(a)):!0}function Ee(e){if(!e)return[];try{const r=JSON.parse(e);return Array.isArray(r)?r:[]}catch{return[]}}function L(e){return e.split("/").pop()||e}const M={},R={},E={};let p=class extends ie(re(te)){constructor(){super(...arguments),this.template="product-card",this.urlPostfix="",this.applyUniqueId=!1,this.preventNavigation=!1,this._selectedSwatchVariant=null,this._pendingPillSelections={},this._isMobileOverlayOpen=!1,this._isNearViewport=!1,this.uniqueId=Math.random().toString(36).substring(2,9),this._swatchClickHandler=this._handleSwatchClick.bind(this),this._isTransitioning=!1,this._viewportObserver=null,this.checkIfResponseHasLayout=e=>e.match(/<(html|body)/),this._loadVariantByIdTask=new D(this,{task:async([e])=>{var t,i,a,o,n,s;if(!e)throw new Error("No variantId provided");if(R[e])return R[e];const r=await this.$api.client.storefront({body:{query:we,variables:{id:`gid://shopify/ProductVariant/${e}`}}});if(!((a=(i=(t=r.data)==null?void 0:t.node)==null?void 0:i.product)!=null&&a.handle))throw new Error("No product handle found");return R[e]=(s=(n=(o=r.data)==null?void 0:o.node)==null?void 0:n.product)==null?void 0:s.handle,R[e]},args:()=>[this.variantId]}),this.loadProductHandleView=new D(this,{task:async([e])=>{if(this.context!=="theme")throw new Error("Not a theme-context card");if(!e)throw new Error("No handle provided");if(M[this.cacheKey])return M[this.cacheKey];const r=await this.$api.client.shopify(this.collectionHandle?`collections/${this.collectionHandle}/products/${e}`:`products/${e}`,{method:"GET",headers:{"Content-Type":"text/html"}},{params:{view:this.template,layout:"none",...this.variantId&&{variant:this.variantId}}});if(this.checkIfResponseHasLayout(r))throw new Error("Invalid response");if(r)return M[this.cacheKey]=r,r;throw new Error("No product found")},args:()=>[this.handle||this._loadVariantByIdTask.value,this.variantId]}),this._loadSnapProductTask=new D(this,{task:async([e])=>{if(this.context==="theme")throw new Error("Not a Snap-context card");if(!e)throw new Error("No handle provided");const r=window.CUSTOMER_COUNTRY||"US",t=`${e}-${r}`;return E[t]??(E[t]=this._enqueueSnapFetch(e,r).catch(i=>{throw delete E[t],i})),E[t]},args:()=>[this._isNearViewport?this.handle:void 0]})}createRenderRoot(){return this}connectedCallback(){super.connectedCallback(),this.preventNavigation&&this.addEventListener("click",this._swatchClickHandler,!0),this._setupViewportObserver()}disconnectedCallback(){var e;super.disconnectedCallback(),this.preventNavigation&&this.removeEventListener("click",this._swatchClickHandler,!0),(e=this._viewportObserver)==null||e.disconnect(),this._viewportObserver=null}_setupViewportObserver(){this.context==="theme"||this._isNearViewport||requestAnimationFrame(()=>{requestAnimationFrame(()=>{!this.isConnected||this._isNearViewport||(this._viewportObserver=new IntersectionObserver(e=>{var r;e.some(t=>t.isIntersecting)&&(this._isNearViewport=!0,(r=this._viewportObserver)==null||r.disconnect(),this._viewportObserver=null)},{rootMargin:"600px 0px"}),this._viewportObserver.observe(this))})})}async _handleSwatchClick(e){const t=e.target.closest(".js-swatch input[data-product-url]");if(!t||!this.closest(".swiper-slide"))return;e.preventDefault(),e.stopPropagation();const a=t.getAttribute("data-product-url");if(!a)return;const o=a.match(/\/products\/([^?#]+)/);if(!o)return;const n=o[1];if(n===this.handle||this._isTransitioning)return;this._isTransitioning=!0,this.dispatchEvent(new CustomEvent("variant-change-requested",{bubbles:!0,composed:!0,detail:{newHandle:n}}));const s=`${n}-${this.variantId}-${this.template}-${this.collectionHandle}`;let c;if(M[s])c=M[s];else try{const l=await this.$api.client.shopify(this.collectionHandle?`collections/${this.collectionHandle}/products/${n}`:`products/${n}`,{method:"GET",headers:{"Content-Type":"text/html"}},{params:{view:this.template,layout:"none",...this.variantId&&{variant:this.variantId}}});M[s]=l,c=l}catch(l){console.error("Failed to load product:",l),this._isTransitioning=!1;return}this.applyUniqueId&&(c=c.replace(/###uid###/g,this.uniqueId)),this.innerHTML=c,this.handle=n,this._renderPostfix(),this._applyImageOverride(),requestAnimationFrame(()=>{this._isTransitioning=!1,this.dispatchEvent(new CustomEvent("card-updated",{bubbles:!0,composed:!0}))})}get cacheKey(){return`${this.handle}-${this.variantId}-${this.template}-${this.collectionHandle}`}static _drainSnapFetchQueue(){for(;p._snapFetchInFlightCount<p._MAX_CONCURRENT_SNAP_FETCHES&&p._snapFetchQueue.length>0;){const e=p._snapFetchQueue.shift();if(!e)break;p._snapFetchInFlightCount++,e.run().finally(()=>{p._snapFetchInFlightCount--,p._drainSnapFetchQueue()})}}_enqueueSnapFetch(e,r){return new Promise((t,i)=>{const a=this.getBoundingClientRect().top;p._snapFetchQueue.push({priority:a,run:()=>this._fetchSnapProductData(e,r).then(t,i)}),p._snapFetchQueue.sort((o,n)=>o.priority-n.priority),p._drainSnapFetchQueue()})}async _fetchSnapProductData(e,r){var a,o;const t=await this.$api.client.storefront({body:{query:xe,variables:{handle:e,country:r}}});if((a=t.data)!=null&&a.product)return this._toSnapCardData(t.data);const i=await this.$api.client.storefront({body:{query:_e,variables:{handle:e,country:r}}});if(!((o=i.data)!=null&&o.product))throw new Error("No product found");return await this._loadSwatchVariants(i.data.product,r),this._toSnapCardData(i.data)}_toSnapCardData(e){var t,i,a;if(!e.product)throw new Error("No product found");const r=((a=(i=(t=e.badgePriority.nodes[0])==null?void 0:t.badges)==null?void 0:i.references)==null?void 0:a.nodes.map(o=>o.handle))??[];return{product:e.product,badgePriorityHandles:r}}async _loadSwatchVariants(e,r){var n;const t=e.options.find(s=>s.name.toLowerCase()==="color")??e.options[0];if(!t)return;const i=t.optionValues.map(s=>s.id);if(!i.length)return;const a=await this.$api.client.storefront({body:{query:$e,variables:{ids:i,country:r}}}),o=new Map((((n=a.data)==null?void 0:n.nodes)??[]).filter(s=>s!==null).map(s=>[s.id,s.firstSelectableVariant]));for(const s of t.optionValues)s.firstSelectableVariant=o.get(s.id)??null}_handleSwatchSelect(e,r){const t=e.firstSelectableVariant;if(t){if(t.product.handle!==r){this._selectedSwatchVariant=null,this._pendingPillSelections={},this._isMobileOverlayOpen=!1,this.handle=t.product.handle;return}this._selectedSwatchVariant=t,this._pendingPillSelections={}}}_renderSwatches(e,r,t){var o;const i=e.filter(H),a=((o=e.find(n=>n.name==="Color"))==null?void 0:o.optionValues.length)??0;return!i.length&&a===0?y:u`
      <div class="grid grid-cols-1 grid-rows-1">
        ${i.map(n=>{var b;const s=n.optionValues.length>F,c=(b=t==null?void 0:t.find(h=>h.name===n.name))==null?void 0:b.value,l=c?n.optionValues.findIndex(h=>h.name===c):-1,d=s&&l>=F?[...n.optionValues.slice(0,F-1),n.optionValues[l]]:s?n.optionValues.slice(0,F):n.optionValues,g=n.optionValues.length-d.length;return u`
            <div
              role="radiogroup"
              aria-label="${n.name}"
              class="col-start-1 row-start-1 max-lg:hidden lg:invisible lg:overflow-hidden lg:opacity-0 lg:transition-[opacity,visibility] lg:duration-300 lg:ease-in-out lg:group-hover:visible lg:group-hover:opacity-100"
            >
              <div class="flex flex-wrap items-center justify-start gap-2xs">
                ${d.map((h,w)=>{var k;const S=`snap-swatch-${this.uniqueId}-${n.name}-${w}`,_=h.name===((k=t==null?void 0:t.find(O=>O.name===n.name))==null?void 0:k.value),{color:x,imageUrl:C}=Z(h),V=`--swatch--background: ${x||"#fff"};${C?"":x?` background-color: ${x};`:""}`,f=C?`background-image: url(${N(C,50)}); background-size: 200%; background-position: center;`:"";return u`
                    <div class="js-swatch group/swatch peer">
                      <input
                        type="radio"
                        id="${S}"
                        name="snap-swatch-${n.name}-${this.uniqueId}"
                        value="${h.name}"
                        class="sr-only"
                        ?checked=${_}
                        @change=${()=>this._handleSwatchSelect(h,r.handle)}
                      />
                      <label
                        for="${S}"
                        title="${h.name}"
                        class="caption block cursor-pointer"
                      >
                        <span
                          class="relative block aspect-square size-[20px] max-w-full border border-[transparent] ring-[--swatch--background] ring-offset-2 transition duration-300 ease-in-out group-has-[:checked]/swatch:border-t-foreground"
                          style="${V}"
                        >
                          ${C?u`<span
                                class="absolute inset-0.5 block overflow-clip"
                                style="${f}"
                              ></span>`:y}
                        </span>
                        <span class="sr-only">${h.name}</span>
                      </label>
                    </div>
                  `})}
                ${g>0?u`<span class="caption text-t-foreground-secondary"
                      >+${g}</span
                    >`:y}
              </div>
            </div>
          `})}
        ${a>0?u`<p
              class="text-body-small col-start-1 row-start-1 text-t-foreground-secondary lg:group-hover:invisible"
            >
              ${a} ${a===1?"color":"colors"}
            </p>`:y}
      </div>
    `}_renderPillOptions(e,r){const t=e.options.filter(s=>!H(s));if(!t.length)return y;const i=t.length>1,a=t.filter((s,c)=>t.slice(0,c).every(l=>this._pendingPillSelections[l.name]!==void 0)),o=this._isMobileOverlayOpen?"pointer-events-auto":"pointer-events-none",n=this._isMobileOverlayOpen?"opacity-100 translate-y-0":"opacity-0 translate-y-full";return u`
      <div
        class="${o} absolute bottom-0 left-0 right-0 z-20 grid grid-cols-1 lg:pointer-events-none lg:group-hover:pointer-events-auto"
      >
        ${a.map(s=>{const c=s.name.toLowerCase(),l=t.indexOf(s)===t.length-1,d=i?l?`Select ${c} and add to bag`:`Select ${c}`:`Add ${c} to bag`;return u`
            <div
              role="radiogroup"
              aria-label="${d}"
              class="js-variant-picker-overlay ${n} col-start-1 row-start-1 h-fit w-full content-end self-end bg-t-background transition-[transform,opacity] duration-500 ease-in-out p-xs lg:translate-y-full lg:opacity-0 lg:group-hover:translate-y-0 lg:group-hover:opacity-100"
            >
              <div class="flex items-center justify-between">
                <div
                  class="w-full bg-t-background text-center text-[12px] uppercase leading-[1.2] tracking-[0.01em] text-[#A5A5A5] mb-2xs"
                >
                  ${d}
                </div>
                <button
                  type="button"
                  class="js-mobile-close mr-xs lg:hidden"
                  aria-label="Close"
                  @click=${()=>{this._isMobileOverlayOpen=!1}}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path d="M1 1L11 11M1 11L11 1" stroke="currentColor" />
                  </svg>
                </button>
              </div>
              <div class="flex flex-wrap justify-center gap-[14px]">
                ${Ce(s).map((g,b)=>{const h=`snap-pill-${this.uniqueId}-${s.name}-${b}`,w=this._pendingPillSelections[s.name]===g.name,S={...this._pendingPillSelections,[s.name]:g.name},_=!Pe(e,r,S);return u`
                    <div
                      class="js-pill ${_?"option-sold-out":"option-available"} flex w-auto min-w-6 min-w-max"
                    >
                      <input
                        type="radio"
                        id="${h}"
                        name="snap-pill-${s.name}-${this.uniqueId}"
                        value="${g.name}"
                        class="peer sr-only"
                        ?checked=${w}
                        ?disabled=${_}
                        @change=${()=>this._handlePillSelect(e,r,s.name,g,l)}
                      />
                      <label
                        for="${h}"
                        class="${_?"peer-checked:border-none peer-checked:text-t-disabled peer-hover:after:bg-t-disabled":""} caption cursor-pointer whitespace-nowrap py-[5px] uppercase transition duration-300 ease-in-out px-3xs peer-checked:text-t-foreground"
                      >
                        ${g.name.replace(".00","")}
                      </label>
                    </div>
                  `})}
              </div>
            </div>
          `})}
      </div>
    `}async _handlePillSelect(e,r,t,i,a){var n,s;if(this._pendingPillSelections={...this._pendingPillSelections,[t]:i.name},!a)return;const o=this._pendingPillSelections;try{const c=window.CUSTOMER_COUNTRY||"US",d=(s=(n=(await this.$api.client.storefront({body:{query:Se,variables:{handle:e.handle,country:c,selectedOptions:Ve(e,r,o)}}})).data)==null?void 0:n.product)==null?void 0:s.selectedOrFirstAvailableVariant,g=Object.entries(o).every(([b,h])=>d==null?void 0:d.selectedOptions.some(w=>w.name===b&&w.value===h));if(!d||!d.availableForSale||!g)return;this.openCartDrawer(),await this.addItemToCart([{id:L(d.id),quantity:1}]),this._pendingPillSelections={},this._isMobileOverlayOpen=!1}catch(c){console.error("Failed to add to cart:",c)}}_getShopifyRootPrefix(){var r,t;const e=(t=(r=window.Shopify)==null?void 0:r.routes)==null?void 0:t.root;return!e||e==="/"?"":e}_buildProductUrl(e){const r=this._getShopifyRootPrefix();return this.collectionHandle?`${r}/collections/${this.collectionHandle}/products/${e}`:`${r}/products/${e}`}_getWishlistButtonConfig(){return this.template==="product-card-mini"?{buttonClass:"swym-add-to-wishlist absolute right-3 top-3 z-[1] flex size-[18px] group/wishlist shrink-0",iconSize:18}:{buttonClass:"product-card-wishlist-button absolute bottom-[45px] right-3 z-[1] flex size-5 items-center justify-center group/wishlist shrink-0 lg:right-3 lg:top-3 lg:bottom-auto lg:size-4",iconSize:12}}_buildAbsoluteProductUrl(e){return`${window.location.origin}${this._getShopifyRootPrefix()}/products/${e}`}_buildQuickShopUrl(e){return`${window.location.origin}${this._buildProductUrl(e)}`}_splitProductTitle(e){var t;const r=window.productCardSettings;return!(r!=null&&r.nameDelimiter)||r.showNameDelimiterAndVariant?e:((t=e.split(r.nameDelimiter)[0])==null?void 0:t.trim())||e}_computeSnapBadges(e,r){var S,_,x,C,V,f,k,O,G;const t=Ee((S=e.hideBadgesMetafield)==null?void 0:S.value),i=m=>t.some($=>$.includes(m)),a=Me((_=this.cart)==null?void 0:_.attributes),o=[],n=e.selectedOrFirstAvailableVariant,s=2;if(o.length<s&&!i("Pre-order")&&((x=n==null?void 0:n.preOrderMetafield)!=null&&x.value)&&e.availableForSale){const m=new Date(n.preOrderMetafield.value).getTime();!Number.isNaN(m)&&m>Date.now()&&o.push({text:"Pre-order"})}const c=window.productCardSettings.finalSaleBadge,l=c.text||"Final sale";o.length<s&&!i(l)&&((C=e.finalSaleMetafield)==null?void 0:C.value)==="true"&&e.availableForSale&&!c.countryExcluded&&o.push({text:l,textColor:c.textColor,backgroundColor:c.backgroundColor});const d=window.productCardSettings.waitlistBadge,g=d.text||"Waitlist";o.length<s&&!i(g)&&((V=e.waitlistMetafield)==null?void 0:V.value)==="true"&&e.availableForSale&&!d.countryExcluded&&o.push({text:g,textColor:d.textColor,backgroundColor:d.backgroundColor}),o.length<s&&!i("Out of stock")&&window.productCardSettings.showSoldOutBadge&&n&&!n.availableForSale&&o.push({text:"Out of stock"});const b=((k=(f=n==null?void 0:n.customBadgesMetafield)==null?void 0:f.references)==null?void 0:k.nodes)??[],h=b.length>0?b:((G=(O=e.customBadgesMetafield)==null?void 0:O.references)==null?void 0:G.nodes)??[],w=m=>{var A,T,W,Q,X,K;const $=(A=m.text)==null?void 0:A.value;return!$||Ie(m)||!Ae(m,a)?null:{text:$,textColor:(T=m.textColor)==null?void 0:T.value,backgroundColor:(W=m.backgroundColor)==null?void 0:W.value,imageUrl:(K=(X=(Q=m.image)==null?void 0:Q.reference)==null?void 0:X.image)==null?void 0:K.url}};for(const m of r){if(o.length>=s)break;const $=h.find(T=>T.handle===m);if(!$)continue;const A=w($);A&&o.push(A)}if(o.length<s)for(const m of h){if(o.length>=s)break;if(r.includes(m.handle))continue;const $=w(m);$&&o.push($)}return o}_renderCardVideo(e,r){const t=`video-${e.id}-desktop`,i=e.previewImage?N(e.previewImage.url,1200):void 0,a=u`
      <video
        id="${t}"
        class="h-full w-full object-cover"
        playsinline
        muted
        loop
        ?autoplay=${r}
        preload="${r?"auto":"none"}"
        poster="${i??""}"
      >
        ${e.sources.map(o=>u`<source src="${o.url}" type="${o.mimeType}" />`)}
      </video>
    `;return u`
      <toggle-play-pause
        data-block-id="${e.id}"
        data-autoplay-when-visible="${r?"true":"false"}"
        class="absolute inset-0 block h-full w-full"
      >
        ${a}
        <button
          type="button"
          class="absolute bottom-[8px] left-[8px] right-auto z-10 flex size-[28px] cursor-pointer items-center justify-center bg-[rgba(255,255,255,0.7)] backdrop-blur-sm md:bottom-[16px] md:left-4 md:size-[40px] lg:bottom-auto lg:left-auto lg:right-3 lg:top-11"
          aria-pressed="${r?"true":"false"}"
          data-play-label="Play video"
          data-pause-label="Pause video"
          aria-label="${r?"Pause video":"Play video"}"
        >
          <svg-icon
            src="icon-play"
            class="js-icon-play${r?" hidden":""}"
            style="--icon-size: 20px;"
            aria-hidden="true"
          ></svg-icon>
          <svg-icon
            src="icon-pause"
            class="js-icon-pause${r?"":" hidden"}"
            style="--icon-size: 20px;"
            aria-hidden="true"
          ></svg-icon>
        </button>
      </toggle-play-pause>
    `}_renderHoverVideo(e,r){return u`
      <div data-hover-video class="absolute inset-0 hidden lg:block">
        ${this._renderCardVideo(e,!1)}
        <a
          class="absolute inset-0 z-[1]"
          href="${r}"
          tabindex="-1"
          aria-hidden="true"
        ></a>
      </div>
    `}_renderSnapCard({product:e,badgePriorityHandles:r}){var V;const t=this._selectedSwatchVariant??e.selectedOrFirstAvailableVariant,i=(V=this._selectedSwatchVariant)==null?void 0:V.image,a=i?[{__typename:"MediaImage",image:i}]:e.media.nodes.filter(f=>f.__typename==="MediaImage"||f.__typename==="Video"),{gallerySlides:o,hoverVideoMedia:n}=ke(a),s=o.length>1,c=this._computeSnapBadges(e,r),l=t==null?void 0:t.price,d=t==null?void 0:t.compareAtPrice,g=!!(l&&d&&parseFloat(d.amount)>parseFloat(l.amount)),b=g&&l&&d?Math.round((parseFloat(d.amount)-parseFloat(l.amount))/parseFloat(d.amount)*100):null,h=this._buildProductUrl(e.handle),w=this._splitProductTitle(e.title),S=[300,500,750,800],_="(min-width: 1024px) 340px, calc(100vw - 64px)",x=this._getWishlistButtonConfig(),C=e.options.some(f=>f.optionValues.length>1);return u`
      <div class="bg-white group relative isolate flex w-full flex-col gap-sm">
        <div class="relative block">
          <product-card-gallery
            class="relative block overflow-hidden"
            style="--core-carousel-slide-width: 100%; --core-carousel-slide-gap-per-slide: 0px; --core-carousel-gap: 0px;"
            data-loop="true"
          >
            <div
              data-carousel-slides
              role="region"
              aria-roledescription="carousel"
              aria-label="Product card carousel for ${w}"
              class="core-carousel-slides"
            >
              ${o.map((f,k)=>{const O=k===0;return u`
                  <div
                    data-carousel-slide
                    class="core-carousel-slide flex w-full flex-shrink-0 flex-grow"
                    role="group"
                    aria-roledescription="slide"
                    tabindex="${O?"0":"-1"}"
                    data-visible="${O?"true":"false"}"
                  >
                    <div class="bg-gray-200 relative aspect-[343/457] w-full">
                      ${f.__typename==="Video"?this._renderCardVideo(f,O):f.__typename==="MediaImage"&&f.image?u`<img
                              class="size-full object-cover object-center"
                              src="${N(f.image.url,800)}"
                              srcset="
                                ${fe(f.image.url,S)}
                              "
                              sizes="${_}"
                              alt="${f.image.altText||e.title}"
                              loading="${O?"eager":"lazy"}"
                            />`:y}
                      <a
                        class="absolute inset-0 z-[1]"
                        href="${h}"
                        data-product-url
                      ></a>
                    </div>
                  </div>
                `})}
            </div>
            ${n&&n.__typename==="Video"?this._renderHoverVideo(n,h):y}
            ${s?u`
                  <button
                    type="button"
                    class="absolute left-3 top-1/2 z-[2] hidden size-5 -translate-y-1/2 items-center justify-center text-t-foreground opacity-0 transition-opacity duration-300 ease-in-out lg:flex lg:group-hover:opacity-100 lg:focus-visible:opacity-100"
                    data-carousel-prev
                    aria-label="Previous product image"
                  >
                    <svg-icon
                      src="icon-caret"
                      class="rotate-180"
                      style="--icon-size: 8px;"
                      aria-hidden="true"
                    ></svg-icon>
                  </button>
                  <button
                    type="button"
                    class="absolute right-3 top-1/2 z-[2] hidden size-5 -translate-y-1/2 items-center justify-center text-t-foreground opacity-0 transition-opacity duration-300 ease-in-out lg:flex lg:group-hover:opacity-100 lg:focus-visible:opacity-100"
                    data-carousel-next
                    aria-label="Next product image"
                  >
                    <svg-icon
                      src="icon-caret"
                      style="--icon-size: 8px;"
                      aria-hidden="true"
                    ></svg-icon>
                  </button>
                `:y}
          </product-card-gallery>

          ${c.length?u`<div
                class="pointer-events-none absolute left-1 top-1 z-[1] lg:left-3 lg:top-3"
              >
                <div class="flex w-fit flex-col gap-3xs" data-product-badges>
                  ${c.map(f=>{const k=[f.textColor?`color: ${f.textColor};`:"",f.backgroundColor?`background-color: ${f.backgroundColor};`:""].join("");return u`<span
                      class="caption-small text-[0.6rem] uppercase text-t-grey-3 lg:text-[0.75rem] lg:leading-[1.4] lg:tracking-normal"
                      style="${k}"
                      >${f.text}
                      ${f.imageUrl?u`<span class="ml-2 w-4"
                            ><img
                              src="${N(f.imageUrl,100)}"
                              alt=""
                              class="w-full"
                          /></span>`:y}</span
                    >`})}
                </div>
              </div>`:y}
          ${t?u`<button
                type="button"
                class="${x.buttonClass}"
                aria-label="${window.productCardSettings.wishlistLabelTemplate.replace("__PRODUCT_NAME__",e.title)}"
                data-swym-shadow-wishlist
                data-with-epi="true"
                data-swaction="addToWishlist"
                data-product-id="${L(e.id)}"
                data-variant-id="${L(t.id)}"
                data-product-url="${this._buildAbsoluteProductUrl(e.handle)}"
              >
                <svg-icon
                  src="icon-heart"
                  class="icon-heart text-p-darkest group-[.disabled]/wishlist:hidden"
                  style="--icon-size: ${x.iconSize}px;"
                  aria-hidden="true"
                ></svg-icon>
                <svg-icon
                  src="icon-heart-filled"
                  class="icon-heart-filled hidden text-t-foreground group-[.disabled]/wishlist:block"
                  style="--icon-size: ${x.iconSize}px;"
                  aria-hidden="true"
                ></svg-icon>
              </button>`:y}
          ${this.template!=="product-card-mini"&&C?u`<button
                type="button"
                class="js-mobile-trigger absolute bottom-3 right-3 z-[1] flex size-5 items-center justify-center bg-t-background text-t-foreground lg:hidden"
                aria-label="${window.productCardSettings.addToCartLabel}"
                @click=${()=>{this._isMobileOverlayOpen=!0}}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path d="M5 0V10M0 5L10 5" stroke="currentColor" />
                </svg>
              </button>`:y}
          ${this.template!=="product-card-mini"?this._renderPillOptions(e,t==null?void 0:t.selectedOptions):y}
          ${this.template!=="product-card-mini"?u`<quick-shop-toggle
                product-url="${this._buildQuickShopUrl(e.handle)}"
                class="absolute bottom-[12px] right-[12px] z-[1] lg:hidden"
              >
                <button
                  type="button"
                  class="js-quick-add-trigger flex size-[20px] items-center justify-center bg-t-background"
                  aria-label="${window.productCardSettings.addToCartLabel}"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path d="M5 0V10M0 5L10 5" stroke="black" />
                  </svg>
                </button>
              </quick-shop-toggle>`:y}
        </div>

        <div class="flex flex-col gap-sm pr-sm">
          <div class="title flex flex-col gap-[4px]">
            <h3 class="text-heading-6 uppercase text-t-foreground">
              <a href="${h}" data-product-url>${w}</a>
            </h3>
            ${l?u`<div
                  class="gap-x-xs caption inline-flex items-center justify-start text-t-foreground"
                >
                  ${g&&d?u`<div class="price-wrapper flex items-center gap-2xs">
                        <div class="flex items-center gap-3xs">
                          <span
                            class="caption bg-t-accent p-0.5 text-t-foreground"
                            >${B(l.amount)}</span
                          >
                          <s class="caption text-t-foreground line-through"
                            >${B(d.amount)}</s
                          >
                        </div>
                        ${b?u`<span
                              class="caption-small text-t-foreground-secondary"
                              >${b}% OFF</span
                            >`:y}
                      </div>`:u`<span class="caption text-t-foreground"
                        >${B(l.amount)}</span
                      >`}
                </div>`:y}
          </div>
          ${this._renderSwatches(e.options,e,t==null?void 0:t.selectedOptions)}
        </div>
      </div>
    `}_renderPostfix(){if(window.__VENDORS__&&!window.__VENDORS__.nosto.enabled||!this.urlPostfix)return;const e=Array.from(this.productUrls);if(e.length!==0)for(const r of e){const t=r;if(t&&(t.href||t.getAttribute("product-url"))){const i=new URL(t.href||t.getAttribute("product-url")),a=this.urlPostfix.split("=");a.length===2?i.searchParams.append(a[0],a[1]):console.error('urlPostfix does not contain exactly one "=" character.'),t.href?t.href=i.toString():t.setAttribute("product-url",i.toString())}}}_applyImageOverride(){if(!this.imageSrcsetOverride)return;const e=this.querySelector("img");e&&e.setAttribute("srcset",this.imageSrcsetOverride)}async updated(){this._renderPostfix(),this._applyImageOverride()}render(){return this.context?u`
      ${this.loadProductHandleView.render({complete:e=>{if(e)return this.applyUniqueId&&(e=e.replace(/###uid###/g,this.uniqueId)),u`${ne(e)}`}})}
    `:u`
        ${this._loadSnapProductTask.render({complete:e=>this._renderSnapCard(e)})}
      `}};p._MAX_CONCURRENT_SNAP_FETCHES=6;p._snapFetchInFlightCount=0;p._snapFetchQueue=[];v([P({type:String,attribute:"variant-id"})],p.prototype,"variantId",2);v([P({type:String})],p.prototype,"handle",2);v([P({type:String,attribute:"collection-handle"})],p.prototype,"collectionHandle",2);v([P({type:String})],p.prototype,"context",2);v([P({type:String})],p.prototype,"template",2);v([P({type:String,attribute:"url-postfix"})],p.prototype,"urlPostfix",2);v([P({type:Boolean,attribute:"apply-unique-id"})],p.prototype,"applyUniqueId",2);v([P({type:Boolean,attribute:"prevent-navigation"})],p.prototype,"preventNavigation",2);v([oe("[data-product-url]")],p.prototype,"productUrls",2);v([z()],p.prototype,"_selectedSwatchVariant",2);v([z()],p.prototype,"_pendingPillSelections",2);v([z()],p.prototype,"_isMobileOverlayOpen",2);v([z()],p.prototype,"_isNearViewport",2);v([P({type:String,attribute:"image-srcset-custom"})],p.prototype,"imageSrcsetOverride",2);p=v([ae("dynamic-product-card")],p);
